import { createReduxAsyncThunk } from 'shared/utils';
import { carsAPI } from 'entities/cars';

import { CARS_STATE } from '../../constants';

import { CarsLocationSharing } from '../../types';

export const getCarsLocationSharing = createReduxAsyncThunk<CarsLocationSharing[]>(
  `${CARS_STATE}/getCarsLocationSharing`,
  async () => {
    const { data } = await carsAPI.getCarsLocationSharing();
    return data;
  }
);
